import { withStyles } from '@material-ui/core';

import LocationsField from './component';
import styles from './styles';

export default withStyles(styles)(LocationsField);
